// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-line {
    font-size: 16px;
    font-weight: bold;
    padding: 8px 16px;
    margin-bottom: -2px;
}
.menu-left {
    font-size: 14px;
    padding-left: 20px;
    float:left;
    font-weight: normal;
}
.menu-right {
    font-size: 13px;
    padding-right: 20px;
    float:right;
    font-weight: normal;
}

.checkbox-position{
    padding-top: 20px;
}
.container-notification {
    flex: 1;
    background: #fff;
    margin-left: 30px;
    margin-right: 30px;
    height: 104%;
}
.menu-title-text {
    font-size: 20px;
    padding: 8px 16px;
    margin-bottom: -2px;
}


.menu-title-all {
    font-size: 20px;
    margin-bottom: -2px;
    align-items:center;
    display:flex;
    justify-content:space-between;
}

.menu-detail-head {
    padding:15px 10px 5px 18px;
}

.menu-detail-sub {
    font-size:16px;
    padding-left:40px;
}

h4 {
    font-weight: normal;
    padding-left: 20px;
}

.menu-title {
    margin-left:-16px;
    align-items: center;
    border-bottom: 1px solid #eaeaea;
    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);
    padding: 15px 10px 5px 0;
}

.menu-header {
    background-color: #fff;
    position: fixed;
    left: 240px;
    top: 50px;
    height: 50px;
    right: 0;
    padding: 0 20px;
    z-index: 5;
}`, "",{"version":3,"sources":["webpack://./src/app/account/profile/notification/edit-notification.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,OAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;;AAGA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,6CAA6C;IAC7C,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,SAAS;IACT,YAAY;IACZ,QAAQ;IACR,eAAe;IACf,UAAU;AACd","sourcesContent":[".tag-line {\n    font-size: 16px;\n    font-weight: bold;\n    padding: 8px 16px;\n    margin-bottom: -2px;\n}\n.menu-left {\n    font-size: 14px;\n    padding-left: 20px;\n    float:left;\n    font-weight: normal;\n}\n.menu-right {\n    font-size: 13px;\n    padding-right: 20px;\n    float:right;\n    font-weight: normal;\n}\n\n.checkbox-position{\n    padding-top: 20px;\n}\n.container-notification {\n    flex: 1;\n    background: #fff;\n    margin-left: 30px;\n    margin-right: 30px;\n    height: 104%;\n}\n.menu-title-text {\n    font-size: 20px;\n    padding: 8px 16px;\n    margin-bottom: -2px;\n}\n\n\n.menu-title-all {\n    font-size: 20px;\n    margin-bottom: -2px;\n    align-items:center;\n    display:flex;\n    justify-content:space-between;\n}\n\n.menu-detail-head {\n    padding:15px 10px 5px 18px;\n}\n\n.menu-detail-sub {\n    font-size:16px;\n    padding-left:40px;\n}\n\nh4 {\n    font-weight: normal;\n    padding-left: 20px;\n}\n\n.menu-title {\n    margin-left:-16px;\n    align-items: center;\n    border-bottom: 1px solid #eaeaea;\n    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);\n    padding: 15px 10px 5px 0;\n}\n\n.menu-header {\n    background-color: #fff;\n    position: fixed;\n    left: 240px;\n    top: 50px;\n    height: 50px;\n    right: 0;\n    padding: 0 20px;\n    z-index: 5;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
